<app-croud-tva
  #croudTva
  (tvaAdded)="loadTvaList()"
  (tvaUpdated)="patchTva($event)">
</app-croud-tva>
<div class=" w-100" >
  <div class="card-body p-0">
    <div *ngIf="isLoading" class="text-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div *ngIf="!isLoading && error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div *ngIf="!isLoading && !error && tvaList.length === 0" class="alert alert-info" role="alert">
      Aucune TVA trouvée.
    </div>
    <table *ngIf="!isLoading && !error && tvaList.length > 0" class="table align-middle ">
        <thead class="custom-thead">
        <tr>
          <th style="padding-right: 200px">Valeur</th>
          <th style="padding-right: 200px">État</th>
            <th style="visibility: hidden;"></th>
          <th >Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tva of tvaList; let i = index">
          <td>{{ getTvaValue(tva) }}</td>
          <td>
            <div class="custom-control custom-switch"
                 [ngClass]="{'custom-control-success': isCheckIcon(tva), 'custom-control-danger': isCrossIcon(tva)}"
                 (click)="toggleTva(tva, $event)">
              <input type="checkbox"
                     [checked]="tva.statut"
                     class="custom-control-input"
                     [id]="'customSwitch' + i"
                     [disabled]="stationId === null || isLoading" />
              <label class="custom-control-label" [for]="'customSwitch' + i"></label>
            </div>
          </td>
            <td></td>

          <td >
            <button class="btn btn-primary btn-sm"
                    (click)="editTva(tva)"
                    [disabled]="stationId === null || isLoading">
              <i data-feather="edit" class="feather-icon icon-15"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
